import { __asStr } from "@tennis-matches/core/utils";

export function computeKoWinners({ schedule, resultsItems }) {
  const ko = schedule?.ko;
  if (!ko) return {};

  const results = normalizeResults(resultsItems);
  const out = {};

  for (const round of ko.rounds || []) {
    const rIdx = Number(round.roundIndex ?? 0);
    const map = {};
    for (const m of round.matches || []) {
      const matchId = __asStr(m.id);
      const matchIndex = Number(m.matchIndex ?? 0); // 1-based
      if (!matchId || !matchIndex) continue;

      const r = results.get(matchId);
      if (!r || r.status !== "confirmed") continue;

      // winner from setsA/setsB
      const setsA = Number(r.setsA ?? 0);
      const setsB = Number(r.setsB ?? 0);
      if (setsA === setsB) continue; // KO: ignore draws

      // determine the actual players later (we only store "A wins" vs "B wins"?)
      // To keep it simple and correct, we store winnerSide: "A" | "B"
      map[matchIndex] = setsA > setsB ? "A" : "B";
    }
    out[rIdx] = map;
  }

  return out;
}

function normalizeResults(items) {
  const map = new Map();
  if (!items) return map;

  if (Array.isArray(items)) {
    for (const x of items) map.set(__asStr(x.matchId), x);
    return map;
  }
  if (typeof items === "object") {
    for (const [k, v] of Object.entries(items)) map.set(__asStr(k), v);
  }
  return map;
}
